import { render, staticRenderFns } from "./UserAssignPolicyForm.vue?vue&type=template&id=a6aeabf0&"
import script from "./UserAssignPolicyForm.vue?vue&type=script&lang=js&"
export * from "./UserAssignPolicyForm.vue?vue&type=script&lang=js&"
import style0 from "./UserAssignPolicyForm.vue?vue&type=style&index=0&id=a6aeabf0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports